export default __webpack_public_path__ + "static/media/down-arrows.2bd23bfb.svg";